export default "__VITE_ASSET__8wRUr381__"